import Emitter from '../../Emitters';

function openCardModal({ product }) {
  Emitter.emit('MODAL_CALL', {
    modal: 'CardModal',
    value: { product },
  });
}

export { openCardModal };
